import { GHANA_BOUNDS } from './geo';

/** Must match `span > 0.12` rejection in GET /map/contributions/pending-survey-geometries. */
export const PENDING_SURVEY_MAX_BBOX_SPAN_DEG = 0.12;

export type MapBbox = { west: number; south: number; east: number; north: number };

export function pendingSurveyBboxSpanDeg(bbox: MapBbox): number {
  return Math.max(Math.abs(bbox.east - bbox.west), Math.abs(bbox.north - bbox.south));
}

export function isPendingSurveyFetchBboxValid(bbox: MapBbox): boolean {
  const { west, south, east, north } = bbox;
  if (![west, south, east, north].every(Number.isFinite)) return false;
  if (east <= west || north <= south) return false;
  return pendingSurveyBboxSpanDeg(bbox) <= PENDING_SURVEY_MAX_BBOX_SPAN_DEG;
}

/** Pending survey tiles are Ghana-only; skip fetch when the viewport cannot intersect Ghana. */
export function pendingSurveyBboxMayHaveData(bbox: MapBbox): boolean {
  const [[minLng, minLat], [maxLng, maxLat]] = GHANA_BOUNDS;
  return (
    bbox.east >= minLng
    && bbox.west <= maxLng
    && bbox.north >= minLat
    && bbox.south <= maxLat
  );
}

export function shouldFetchPendingSurveyGeometries(bbox: MapBbox): boolean {
  return isPendingSurveyFetchBboxValid(bbox) && pendingSurveyBboxMayHaveData(bbox);
}
